export class ValidationErrorResponse{
    constructor(jsonError: any) {
        this.error = jsonError;      
    }

    error: any;
}


//TODO
export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

// TOD
export interface ValidationProblemDetails extends ProblemDetails {
  errors?: { [key: string]: string[] };
}
